/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import STARRED_FILTERS_QUERY, {
	type StarredFiltersContainerQuery,
} from '@jira/navigation-apps__sidebar-common/src/common/ui/starred-filters-container/__generated__/StarredFiltersContainerQuery.graphql';
import type { RouteResource } from '@atlassian/react-resource-router';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const sidebarProjectIssuesResource: RouteResource<
	PreloadedQuery<StarredFiltersContainerQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<StarredFiltersContainerQuery>({
		type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
		// oxlint-disable-next-line no-explicit-any
		getQuery: (_: any, { tenantContext }) => ({
			parameters: STARRED_FILTERS_QUERY,
			variables: {
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	}),
);
